import { Receipt } from "@/modules/finances/receipts/types"
import { Http } from "@/network/http"
import { notificationAction } from "@/utils"
import { Filters, NotificationEnum, StatusEnum } from "@/utils/constants"

export const API_PREFIX_PATH = "/receipts"

export const fetchReceipts = async (filters?: Filters) => {
  return await Http.get(`${API_PREFIX_PATH}`, { params: filters })
}

export const fetchReceipt = async (id: string) => {
  return await Http.get(`${API_PREFIX_PATH}/${id}`)
}

export const createReceipt = async (data?: Receipt) => {
  return await Http.post(`${API_PREFIX_PATH}`, data)
}

export const updateReceipt = async (id: string, data?: Receipt) => {
  return await Http.put(`${API_PREFIX_PATH}/${id}`, data)
}

export const deleteReceipt = async (data: Receipt) => {
  try {
    const updatedData = { ...data }
    if (!updatedData.id) return
    const response = await updateReceipt(updatedData.id, { ...updatedData, status: StatusEnum.DELETED })
    if (response.statusCode === 200) {
      notificationAction(NotificationEnum.DELETED, NotificationEnum.SUCCESS)
    }
  } catch (error) {
    console.error("Addition failed:", error)
    notificationAction(`Lỗi ${error}`, NotificationEnum.ERROR)
  }
}
